if (!customElements.get('byd-popup-product')) {
  class BydPopupProduct extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        popup: '.byd-popup',
        closeBtn: '[popup-close-btn]',
        overlay: '[backdrop-overlay]',
        productTitle: '[product-title]',
        productPrice: '[product-price]',
        productOptions: '[product-options-container]',
        submitBtn: '[addtocart-cta]',
        loaderFixed: '[loading-fixed]',
        loader: '[loader-inner]',
        mediaRing: '[media-ring] img',
        mediaDiamond: '[media-diamond] img',
      };
      this.init();
    }

    init() {
      this.popup = this.querySelector(this.selectors.popup);
      this.closeBtn = this.querySelector(this.selectors.closeBtn);
      this.overlay = this.querySelector(this.selectors.overlay);
      this.productTitle = this.querySelector(this.selectors.productTitle);
      this.productPrice = this.querySelector(this.selectors.productPrice);
      this.productOptions = this.querySelector(this.selectors.productOptions);
      this.submitBtn = this.querySelector(this.selectors.submitBtn);
      this.loader = this.querySelector(this.selectors.loader);
      this.mediaRing = this.querySelector(this.selectors.mediaRing);
      this.mediaDiamond = this.querySelector(this.selectors.mediaDiamond);
      this.loaderFixed = document.querySelector(this.selectors.loaderFixed);

      this.addEventListener('addToCartClicked', (e) => {
        if (this.loader && this.loader.classList.contains('hidden')) {
          this.loader.classList.remove('hidden');
        }
        const button = e.detail.button;
        if (e.detail.image) {
          this.diamondImage = e.detail.image;
        }
        this.buttonID = e.detail.id;
        this.buttonContainer = button?.closest('.byd-product__content');
        this.togglePopUp();
        this.getData();
      });

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => {
          this.togglePopUp();
        });
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => {
          this.togglePopUp();
        });
      }
      this.submitBtn?.addEventListener('click', () => {
        this.addToCart(this.submitBtn);
      });
    }
    async addToCart(btn) {
      try {
        this.loaderFixed.style.display = 'flex';
        const cartData = {
          items: [
            {
              id: `${btn.dataset.diamond}`,
              quantity: "1"
            },
            {
              id: `${btn.dataset.variant}`,
              quantity: "1"
            }
          ]
        };
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(cartData),
        });

        if (!response.ok) {
          throw new Error('Error adding product to cart');
        }
        const data = await response.json();
        console.log(data, "==================");
        localStorage.clear();
        window.location.href = '/cart';

      } catch (error) {
        console.error('Error adding product to cart:', error);
        throw error;
      }
    }

    togglePopUp() {
      if (this.popup) {
        if (!this.popup.classList.contains('active')) {
          this.popup.classList.add('active');
          this.overlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        } else {
          this.popup.classList.remove('active');
          document.body.style.overflow = '';
          this.overlay.classList.remove('active');
        }
      }
    }

    getData() {
      const urlString = sessionStorage.getItem('previousUrl', referrerUrl);
      let modifiedUrlString = urlString.replace(/(\?|&)variant=[^&]+/, '');
      this.variantId = localStorage.getItem('variantId');
      if (modifiedUrlString && this.variantId) {
        this.fetchProduct(modifiedUrlString);
      }
    }

    fetchProduct(url) {
      const fetchUrl = url + '.json';
      fetch(fetchUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          console.log('Data received:', data.product);
          this.productJson = data.product;
          const foundVariant = this.findVariant(data.product.variants, this.variantId);
          this.updateHtml(foundVariant);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
    findVariant(variants, variantId) {
      return variants.find(variant => variant.id === parseInt(variantId));
    }
    updateHtml(variant) {
      console.log(variant);
      const productTitleSource = this.productJson.title;
      const productPriceSource = variant.price;
      this.productTitle.textContent = productTitleSource;
      const currencySymbol = this.productPrice.dataset.currency || '';
      this.productPrice.textContent = currencySymbol + productPriceSource;
      this.productOptions.innerHTML = '';
      const metalOption = variant.option1;
      const sizeOption = variant.option2;
      // MEDIA
      this.mediaRingSrcSource = this.productJson.image.src;
      if (this.mediaRingSrcSource) {
        this.mediaRing.src = this.mediaRingSrcSource;
      }
      if (this.diamondImage) {
        this.mediaDiamond.src = this.diamondImage;
        if (this.mediaDiamond.parentElement.classList.contains('hidden')) {
          this.mediaDiamond.parentElement.classList.add('hidden');
        }
      } else {
        this.mediaDiamond.parentElement.classList.add('hidden');
      }


      this.productOptions.insertAdjacentHTML('beforeend', `<div data-name="option-name"><strong>Metal:</strong> ${metalOption}</div>`);
      this.productOptions.insertAdjacentHTML('beforeend', `<div data-name="option-name"><strong>Size:</strong> ${sizeOption}</div>`);

      // Apend OPTIONS
      const options = this.buttonContainer?.querySelectorAll('[data-name="option-name"]');
      options?.forEach(element => {
        this.productOptions.innerHTML += element.outerHTML;
      });

      this.submitBtn.dataset.diamond = this.buttonID;
      this.submitBtn.dataset.variant = variant.id;
      if (this.loader && !this.loader.classList.contains('hidden')) {
        this.loader.classList.add('hidden');
      }
    }
  }

  customElements.define('byd-popup-product', BydPopupProduct);
}